// extracted by mini-css-extract-plugin
module.exports = {"mobile-text":"ThematixHero_mobile-text__4oAnu","button":"ThematixHero_button__B7i_0"};